



import React, { useState, useEffect, useRef } from 'react';
import { Modal, Spinner, Offcanvas } from 'react-bootstrap';
import axios from 'axios';

const InstanceForm = ({ showModal, handleClose, instanceId, instanceData, addInstance, editInstance, instances }) => {
    const [loading, setLoading] = useState(false); // Track loading state
    const [allInstances, setAllInstances] = useState([]);
    const [formData, setFormData] = useState({
        key: '',
        setup_name: '',
        setup_id: '',
        setup_mode: '',
        setup_type: 'direct',
        address: '',
        max_tenants: '',
        max_process: '',
        contact_type: '',
        active_status: 'active',
        remarks: '',
        partner_name: '',

    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (showModal && !instanceData) {
            // Reset formData for new instance creation
            setFormData({
                key: '',
                setup_name: '',
                setup_id: '',
                setup_mode: '',
                max_tenants: '',
                max_process: '',
                setup_type: '', // Default value
                address: '',
                contact_type: '',
                active_status: 'active',
                remarks: '',
                partner_name: '',
            });
        } else if (instanceData) {
            // Populate formData for editing an instance
            setFormData({
                key: instanceData.key || '',
                setup_name: instanceData.setup_name || '',
                setup_id: instanceData.setup_id || '',
                setup_mode: instanceData.setup_mode || '',
                setup_type: instanceData.setup_type || '',
                address: instanceData.address || '',
                max_tenants: instanceData.max_tenants || '',
                max_process: instanceData.max_process || '',
                contact_type: instanceData.contact_type || '',
                active_status: instanceData.active_status || '',
                remarks: instanceData.remarks || '',
                partner_name: instanceData.partner_name || '',
            });
        }
    }, [instanceData, showModal]);



    const handleChange = (e) => {
        const { name, value } = e.target;
        // setFormData((prev) => ({ ...prev, [name]: value }));
        setFormData((prev) => {
            const newFormData = { ...prev, [name]: value };
            return newFormData;
        });
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.setup_name) newErrors.setup_name = 'Setup Name is required';
        if (!formData.setup_id) newErrors.setup_id = 'Setup ID is required';
       const duplicateInstance = Array.isArray(instances) && instances.some(

            (instance) => instance.setup_id === formData.setup_id && instance.id !== instanceId &&
                !instance.deleted_at
        );


        if (duplicateInstance) {
            newErrors.setup_id = 'Setup ID must be unique';
        }




        return newErrors;
    };

    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }
        try {
            let apiErrors;
            if (instanceData) {
                apiErrors = await editInstance(instanceData.id, formData);
            } else {
                apiErrors = await addInstance(formData);
            }

            if (apiErrors && Object.keys(apiErrors).length > 0) {
                setErrors(apiErrors);
            } else {
                setErrors({});
                handleClose();
            }
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>

        <Offcanvas show={showModal} onHide={handleClose} placement="end"  style={{ width: '680px' }}>   
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{instanceId ? 'Edit Instance' : 'Add Instance'}</Offcanvas.Title>
            </Offcanvas.Header>
            <hr style={{ margin: 0 }} /><br/>

            <Offcanvas.Body>
                <form>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label style={{ fontSize: "13px" }} htmlFor="setup_id" className="form-label">Setup ID:</label>
                                <input
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="setup_id"
                                    id="setup_id"
                                    className={`form-control ${errors.setup_id ? 'is-invalid' : ''}`}
                                    value={formData.setup_id}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.setup_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.setup_id}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="setup_name" style={{ fontSize: "13px" }} className="form-label">Setup Name:</label>
                                <input
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="setup_name"
                                    id="setup_name"
                                    className={`form-control ${errors.setup_name ? 'is-invalid' : ''}`}
                                    value={formData.setup_name}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.setup_name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.setup_name}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="key" className="form-label" style={{ fontSize: "13px" }}>Key:</label>
                                <input
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="key"
                                    id="key"
                                    className="form-control"
                                    value={formData.key}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="setup_mode" style={{ fontSize: "13px" }} className="form-label">Setup Mode:</label>
                                <select
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="setup_mode"
                                    value={formData.setup_mode}
                                    className="form-control"

                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Type</option>

                                    <option value="single">Single</option>
                                    <option value="multi">Multi</option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <div className="row">

                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="address" style={{ fontSize: "13px" }} className="form-label">Address:</label>
                                <textarea
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="address"
                                    className="form-control"
                                    value={formData.address}
                                    onChange={handleChange}

                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="max_tenants" style={{ fontSize: "13px" }} className="form-label">Max Tenants:</label>
                                <input
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="number"
                                    name="max_tenants"
                                    id="max_tenants"
                                    className="form-control"
                                    value={formData.max_tenants}
                                    onChange={handleChange}

                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="max_process" style={{ fontSize: "13px" }} className="form-label">Max Process:</label>
                                <input
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="number"
                                    name="max_process"
                                    id="max_process"
                                    className="form-control"
                                    value={formData.max_process}
                                    onChange={handleChange}

                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label style={{ fontSize: "13px" }} htmlFor="contact_type" className="form-label">Contact Type:</label>
                                <select
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="contact_type"
                                    value={formData.contact_type}
                                    className="form-control"

                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Type</option>

                                    <option value="owner">Owner</option>
                                    <option value="partner">Partner</option>
                                </select>
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label style={{ fontSize: "13px" }} htmlFor="setup_type" className="form-label">Setup Type:</label>
                                <select
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="setup_type"
                                    value={formData.setup_type}
                                    className="form-control"

                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Type</option>

                                    <option value="direct">Direct</option>
                                    <option value="partner">Partner</option>
                                    <option value="R&D">R&D</option>
                                </select>
                            </div></div>
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label htmlFor="remarks" style={{ fontSize: "13px" }} className="form-label">Remarks:</label>
                                <textarea
                                    style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="remarks"
                                    id="remarks"
                                    className="form-control"
                                    value={formData.remarks}
                                    onChange={handleChange}

                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <label style={{ fontSize: "13px" }} htmlFor="active_status" className="form-label">Status:</label>
                                <select
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="active_status"
                                    value={formData.active_status}
                                    className="form-control"

                                    onChange={handleChange}
                                >
                                    <option value="">Select Status</option>

                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                    <option value="suspended">Suspended</option>
                                </select>
                            </div></div>
                        {formData.setup_type === 'partner' && (
                            <div className="col-md-6">
                                <div className="form-group  mb-3">
                                    <label htmlFor="partner_name" style={{ fontSize: "13px" }} className="form-label">Partner Name:</label>
                                    <input
                                        style={{ fontSize: '13px', maxWidth: '290px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        type="text"
                                        name="partner_name"
                                        id="pertner_name"
                                        className="form-control"
                                        value={formData.partner_name}
                                        onChange={handleChange}

                                    />
                                </div>
                            </div>
                        )}
                        <br />
                    </div>            
                    </form>
            </Offcanvas.Body>

            {/* Manually added footer */}
            <div className="p-3 border-top  d-flex justify-content-end">
                <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                    Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Saving...
                        </>
                    ) : (
                        'Save'
                    )}
                </button>
            </div>
        </Offcanvas>

        </>
    );
};

export default InstanceForm;



